import CookiesManager from './CookiesManager';

const Conditions = {
    showWidget: () => !CookiesManager.checkDisablingProactiveCookie()
};

export default Conditions;
